import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { GuidedHouseholdReviewSections } from 'Components/UI/guidedHouseholdReview/sections';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewCashFlowLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <>
      <GuidedHouseholdReviewSections metaOverrideSet={metaOverrideSet} collection={resource.attr('sections')} />
    </>
  );
};
